export default {
  'Cases types': 'VÄSKTYPER',
  'Possible contents of the case': 'Möjligt innehåll i väskan',
  'Other cases': 'ANDRA VÄSKOR',
  'Open for': 'Öppen för',
};
